import { render, staticRenderFns } from "./navigationList.vue?vue&type=template&id=c751abd4&scoped=true"
import script from "./navigationList.vue?vue&type=script&lang=js"
export * from "./navigationList.vue?vue&type=script&lang=js"
import style0 from "./navigationList.vue?vue&type=style&index=0&id=c751abd4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c751abd4",
  null
  
)

export default component.exports